const axios = require("axios");
const qs = require("qs");
import config from "@/http/config";
import router from "@/router/router";
import NProgress from "nprogress";
import { MessageBox } from "element-ui";
import Message from "@/utils/message";
import "nprogress/nprogress.css";
import i18n from "../utils/i18n";
const cookie = require("js-cookie");
let count = true;
NProgress.configure({ showSpinner: false });
axios.defaults.withCredentials = true;
export default function $axios(options) {
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: config.baseUrl,
      headers: {
        appId: "123456789"
      },
      timeout: config.timeout,
      // Serialize arrays without brackets for Spring Boot compatibility
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      transformResponse: [
        function (data) {
          return data;
        }
      ]
    });
    // request 拦截器
    instance.interceptors.request.use(
      config => {
        NProgress.start();
        let token = cookie.get("token");
        if (token && options.url !== "login") {
          config.headers.token = token;
        } else {
          // 重定向到登录页
          if ("/login" !== router.history.current.path) {
            //  改
            router.push("/login");
          }
          NProgress.done();
        }
        return config;
      },
      error => {
        // 需要重定向到错误页
        const errorInfo = error.response;
        if (errorInfo) {
          // error = errorInfo.data  //页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
          const errorStatus = errorInfo.status;
          router.push({
            path: `/error/${errorStatus}`
          });
        }
        return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    );

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        let result;
        if (response.request.responseType === "blob") {
          result = response;
        } else {
          if (response.data) {
            result = JSON.parse(response.data);
          } else {
            // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
            let res = response.request.responseText;
            if (res && res !== "") {
              result = JSON.parse(response.request.responseText);
            }
          }
        }

        // 根据返回的code值来做不同的处理
        switch (result.code) {
          case -1:
            Message.warning({
              message: result.msg,
              duration: 2000,
              showClose: false
            });
            break;
          case 2:
            Message.warning({
              message: result.msg,
              duration: 2000,
              showClose: false
            });
            break;
          case 0:
            // 正常的请求返回
            break;
          case 401:
            Message.warning({
              message: result.msg,
              duration: 2000,
              showClose: false
            });
            break;
          case 403:
            if ("/login" !== router.history.current.path) {
              if (count) {
                count = false;
                MessageBox.confirm(result.msg, "Session Expired", {
                  confirmButtonText: i18n.t("common.definite"),
                  cancelButtonText: i18n.t("common.cancel"),
                  beforeClose: (action, instance, done) => {
                    count = true;
                    done();
                  }
                }).then(() => {
                  router.push("/login");
                });
              }
            }
            break;
          default:
        }

        /**
         * 若不是正确的code，且已登录，就抛出异常
         * const err = new Error(data.desc)
         * err.data = data
         * err.response = response
         * throw err
         * */
        NProgress.done();
        return result;
      },
      error => {
        NProgress.done();
        // 判断请求超时
        if (error.code === "ECONNABORTED" || error.message.indexOf("timeout") !== -1) {
          Message.warning(i18n.t("api.rto"));
        } else if (!error.response) {
          // 网络错误/CORS 没有响应体
          Message.error(error.message);
        } else {
          switch (error.response.status) {
            case 400:
              error.message = i18n.t("api.re");
              break;
            case 401:
              error.message = i18n.t("api.upl");
              break;
            case 403:
              error.message = i18n.t("api.ad");
              break;
            case 404:
              error.message = i18n.t("api.eir") + ":" + error.response.config.url;
              break;
            case 408:
              error.message = i18n.t("api.rto");
              break;
            case 500:
              error.message = i18n.t("api.ise");
              break;
            case 501:
              error.message = i18n.t("api.sini");
              break;
            case 503:
              error.message = i18n.t("api.sin");
              break;
            case 504:
              error.message = i18n.t("api.gt");
              break;
            case 505:
              error.message = i18n.t("api.vins");
              break;
            default:
          }
          Message.error(error.message);
        }
        return Promise.reject(error); // 返回接口错误信息
      }
    );

    // 请求处理
    instance(options)
      .then(res => {
        resolve(res);
        return false;
      })
      .catch(error => {
        reject(error);
      });
  });
}
